import React from "react";
import map from "lodash/map";

import moment from "moment";
import MetricsFoot from "../../../athlete-portal/metrics/MetricsFoot";
import MetricsBackButton from "../../../athlete-portal/metrics/metrics-back-button";
import set from "@rill/set";

function View(props, { locals }) {
  const { listCustomMetrics } = locals;
  return (
    <div className="Main Metrics">
      <MetricsBackButton url={`/dashboard/metrics`} />
      <div className="CMR-Head">
        <h1 className="custom-report alt">Custom Reports List</h1>
        <span className="description">
          Analyze your training metrics with complete flexibility. Take any data
          point we track, and slice and dice it any way you want. Create custom
          reports, save them, and track what's important to you.
        </span>
        <a className="add-new" href={`/dashboard/metrics/custom/edit`}>
          Create Custom Report
        </a>
      </div>

      <div className="CMR-Archive">
        {map(listCustomMetrics, (customMetric, i) => {
          return (
            <div className="item" key={customMetric._id}>
              <div className="name">{customMetric.name}</div>
              <div className="date">
                {moment.utc(customMetric.date).format("MMM DD, YYYY")}
              </div>
              <a
                className="link"
                href={`/dashboard/metrics/custom/view/${customMetric._id}`}
              />
            </div>
          );
        })}
      </div>
      <MetricsFoot shareHref="/actions/refresh?modal[type]=share" />
    </div>
  );
}

const List = (app) => {
  app.get(
    "/list",
    set("heading", "Custom Metrics Reports"),
    async ({ res, load }) => {
      await load("listCustomMetrics");
      res.body = <View />;
    }
  );
};

export default List;
